import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import Spinner from "./components/spinner/Spinner";


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <Suspense fallback={<Spinner />}> */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      {/* </Suspense> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
